import React from 'react';

import css from './Hero.module.css';
const Hero = props => {
  const { title } = props;
  return (
    <div className={css.hero}>
      <div className={css.heroBackground}>
        <div className={css.heroBackgroundOverlay} />
        <div
          className={[css.heroBackgroundImage].join(' ')}
          style={{
            backgroundImage: `url('https://dsqeev865ph38.cloudfront.net/production/static/national_parks/images/index/default-hero.1e55be52952e.png')`,
          }}
        />
      </div>
      <h1 className="relative px-4 z-1">{title}</h1>
    </div>
  );
};

export default Hero;
